import { Box, Paper, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const PurchaseCharts = ({ breakEven }: { breakEven: number | undefined }) => {
  const { t } = useTranslation("dashboard");

  return (
    <Paper
      variant="outlined"
      sx={{
        boxShadow: " 0px 3px 8px 0px rgba(0, 0, 0, 0.15)",
        borderRadius: "8px",
        p: 3,
        height: "100%",
      }}
    >
      <Typography
        lineHeight={"22px"}
        textTransform={"capitalize"}
        fontWeight={500}
        color={"#334155"}
        mb={"22px"}
      >
        {t("breakEven")}
      </Typography>

      <Box
        display={"flex"}
        justifyContent={"center"}
        alignItems={"center"}
        height={300}
      >
        <Typography fontSize={"64px"} color={"#3333E9"}>
          {breakEven}
        </Typography>
      </Box>
    </Paper>
  );
};

export default PurchaseCharts;
